import { Store } from 'react-notifications-component';
import React from 'react';
import { Toaster } from '@piplapps/pipl-ui';
import { createBrowserHistory } from 'history';
import styles from '../Components/Toaster/Toaster.module.less';

export const sleep = (delay) =>
  new Promise((resolve, reject) => {
    setTimeout(resolve, delay);
  });

export const history = createBrowserHistory();

window.reactHistory = history;

export const getTranslation = (textKey, lang = 'en') => {
  if (!textKey) return null;

  const language = ['en', 'es', 'ps'].includes(lang.toLowerCase()) ? lang.toLowerCase() : 'en';
  const translation = window.__CONFIG__.TRANSLATIONS[textKey.toUpperCase()];
  return translation ? translation[`text_${language}`] : textKey;
};

export const getUsecaseCategoryOptions = (parentCategory = null) => {
  let options = window.__CONFIG__.USE_CASES;
  if (parentCategory !== null) {
    const index = options.findIndex((item) => item.category.id === parentCategory);
    if (index > -1) {
      options = window.__CONFIG__.USE_CASES[index].sub_categories;
    }
  }

  const optionsList = options.map((option, i) => {
    const value = parentCategory === null ? option.category : option;

    return {
      label: getTranslation(value.text_key),
      value: value.id,
    };
  });

  return optionsList;
};

export const getUsecaseCategoryById = (categoryId) => {
  const options = window.__CONFIG__.USE_CASES;
  const index = options.findIndex((item) => item.category.id === categoryId);
  return index > -1 ? options[index].category : null;
};

export const getUsecaseCategoryByCode = (code) => {
  const options = window.__CONFIG__.USE_CASES;
  const index = options.findIndex((item) => item.category.text_key === code);
  return index > -1 ? options[index].category : null;
};

export const getUsecaseSubCategoryById = (parentCategoryId, subCategoryId) => {
  let options = window.__CONFIG__.USE_CASES;
  const index = options.findIndex((item) => item.category.id === parentCategoryId);
  if (index === -1) {
    return null;
  }
  options = window.__CONFIG__.USE_CASES[index].sub_categories;

  const subIndex = options.findIndex((item) => item.id === subCategoryId);
  return subIndex > -1 ? options[subIndex] : null;
};

export const getUsecaseSubCategoryByCode = (parentCategoryCode, subCategoryCode) => {
  let options = window.__CONFIG__.USE_CASES;
  const index = options.findIndex((item) => item.category.text_key === parentCategoryCode);
  if (index === -1) {
    return null;
  }
  options = window.__CONFIG__.USE_CASES[index].sub_categories;

  const subIndex = options.findIndex((item) => item.code === subCategoryCode);
  return subIndex > -1 ? options[subIndex] : null;
};

export const validateBasicEmail = (email) => {
  const regexEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !(email?.length > 0 && !regexEmail.test(email));
};

export const validateWebsite = (website) => {
  return !(
    website?.length > 0 &&
    !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g.test(website)
  );
};

export const validatePhone = (phone) => {
  return !(phone?.length > 0 && !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(phone));
};

export const getUseCaseTextFromKey = (key) => {
  const useCases = {
    CONTACT_ENRICHMENT: 'Contact Enrichment',
    INVESTIGATION: 'Investigations',
    IDENTITY_VERIFICATION: 'Identity Verification',
    BACKGROUND_CHECK: 'Background Check',
    OTHER: 'Other',
  };
  return useCases[key];
};

export const displayNotification = (type, title, message) => {
  try {
    return Store.addNotification({
      title,
      message,
      type,
      insert: 'top',
      container: 'top-right',
      animationIn: ['animated'],
      animationOut: ['animated', styles.fadeOut],
      slidingExit: {
        duration: 200,
        timingFunction: 'ease-out',
        delay: 0,
      },
      slidingEnter: {
        duration: 500,
        timingFunction: 'ease-in',
        delay: 0,
      },
      dismiss: {
        duration: 5000,
        touch: true,
      },
      content: <Toaster title={title} body={message} type={type} id="notification-alert" />,
    });
  } catch (error) {}
};
